import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueQuill from 'vue-quill';
import VueTreeList from 'vue-tree-list';

import App from './App.vue';
import router from './router';

import './assets/scss/app.scss';

if (window && window.location && window.location.host === 'portal.arvcstg.net') {
  window.location.href = 'https://portal.arvc.org';
}

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueQuill);
Vue.use(VueTreeList);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
